import { Typography as MuiTypography, TypographyProps } from '@mui/material';
import type { TypographyVariant } from '@mui/material/styles';
import { forwardRef } from 'react';
import { toLinkProps } from '../utils/toLinkProps';

type TypographyV2Variant = TypographyVariant | 'micro1' | 'micro2';

type Props = Pick<
  TypographyProps,
  | 'children'
  | 'component'
  | 'id'
  | 'align'
  | 'noWrap'
  | 'gutterBottom'
  | 'color'
  | 'className'
  | 'sx'
  | 'onClick'
  | 'onKeyDown'
  | 'role'
  | 'tabIndex'
  | 'title'
  | 'aria-hidden'
> & {
  variant?: TypographyV2Variant | 'inherit';
  to?: string;
  testId?: string;
};

const Typography = forwardRef<HTMLElement, Props>(
  (
    {
      variant,
      children,
      component,
      id,
      align,
      noWrap,
      gutterBottom,
      color,
      to,
      testId,
      onClick,
      onKeyDown,
      role,
      tabIndex,
      title,
      className,
      sx,
      'aria-hidden': ariaHidden,
    },
    ref,
  ) => (
    <MuiTypography
      variant={variant as TypographyProps['variant']}
      {...(component !== undefined && { component })}
      id={id}
      align={align}
      noWrap={noWrap}
      gutterBottom={gutterBottom}
      color={color}
      title={title}
      test-id={testId}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={role}
      tabIndex={tabIndex}
      aria-hidden={ariaHidden}
      className={className}
      sx={sx}
      ref={ref}
      {...toLinkProps(to)}
    >
      {children}
    </MuiTypography>
  ),
);

Typography.displayName = 'Typography';
export type { Props as TypographyProps };
export default Typography;
